import { useStaticQuery, graphql } from 'gatsby';
import { cond, T, path } from 'ramda';

import i18n from '@/utils/i18n';

export default () => {
  const data = useStaticQuery(graphql`
    query ContactFooterQuery {
      enJson(contact: { id: { eq: "contact" } }) {
        contact {
          common {
            phone {
              name
              url
            }
            email {
              name
              url
            }
          }
        }
      }
      deJson(contact: { id: { eq: "contact" } }) {
        contact {
          common {
            phone {
              name
              url
            }
            email {
              name
              url
            }
          }
        }
      }
    }
  `);

  return cond([
    [i18n.isEn, path(['enJson', 'contact'])],
    [i18n.isDe, path(['deJson', 'contact'])],
    [T, path(['enJson', 'contact'])],
  ])(data);
};
